module.exports = __webpack_public_path__ + "static/assets/5ab362f7d3b035cf25cfc0c1a253c408.svg";